import { Component, Prop } from 'vue-property-decorator'
import { createDecorator } from 'vue-class-component'
import { isFunction, keys, pickBy } from 'lodash'

import EventMixin from './event'


/**
 * Validator decorator for class based vue components.
 *
 * @param name The name of the validator.
 * @param isDefault Should the validator be executed by default.
 */
export function Validator (name?: string, isDefault: boolean = false) {
  return createDecorator((options, key) => {
    const validators = (options.validators || (options.validators = {}))
    validators[name || key] = { handler: key, default: isDefault }
  })
}


@Component
export default class extends EventMixin {
  state: boolean | null = null

  @Prop({ type: Array, default: () => [] })
  validators!: any[]

  @Prop({ type: Boolean, default: false })
  required!: boolean

  get defaultValidators () {
    const validators = this.$options.validators || {}
    return keys(pickBy(validators,
        value => isFunction(value) ? false : value.default))
  }

  get computedValidators () {
    const validators = [
      ...this.defaultValidators,
      ...this.validators
    ]

    // add required validator by default if required prop is passed
    if (this.required) {
      validators.push('required')
    }

    // get only the unique validators
    return Array.from(new Set(validators))
  }

  validate (value: any): boolean {
    // perform validation against all validators
    return this.state = this.computedValidators
      .every(v => {
        let handler = v
        let options
        if (typeof v === 'object') {
          handler = v.name
          options = v.options
        }
        let validator: any = (this.$options.validators || {})[handler]
        if (typeof validator === 'object') {
          validator = validator.handler
          if (typeof validator === 'string') {
            validator = this.$options.methods && this.$options.methods[validator]
          }
        }
        // Call the validator function, passing the widget as context
        const state = validator
          ? validator.call(this, value, options)
          : true

        // Broadcast validation events.
        const event = state ? 'validated' : 'invalidated'
        this.broadcastEvents(`${event}:${handler}`)

        return state
      })
  }
}
